import { MultiSelect, MultiSelectProps } from "@/components/pages/samples/MultiSelect";
import { useAppDispatch, useAppSelector } from "@/store/store";
import { sampleSettingsSelector } from "@/store/slices/samplesSlice";
import { setModalOpen } from "@/store/actions/samplesActions";

type SamplesMultiSelectProps = MultiSelectProps;

export const SamplesMultiSelect = (props: SamplesMultiSelectProps) => {
  const { modalOpen } = useAppSelector(sampleSettingsSelector);
  const dispatch = useAppDispatch();

  return (
    <MultiSelect {...props} onToggle={(value) => dispatch(setModalOpen(value))} forceClose={!modalOpen} />
  );
};
